export default "__VITE_ASSET__3NiSsoMT__"